export default __webpack_public_path__ + "static/media/No-owlfuse-pic.36f45740.png";